<template lang="pug">
  adv-master(
    v-if="bannerPropById.id"
    class="banner-container"
    :bannerProp="bannerPropById"
    :env="env"
    :systemCode="systemCode"
    @onEvent="handleAdvEvent"
  )
</template>

<script>
import { AdvMaster } from '@hb/h5-components-new';
import { getSystemCode } from '@/utils/systemCode';
import config from '@/const/config';

export default {
  name: 'AdvResource',
  components: {
    AdvMaster,
  },
  props: {
    resourceId: {
      type: String,
      required: true,
    },
    borderRadius: {
      type: Number,
      default: 0,
    },
    customClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      env: config.env === 'dev' ? 'fat' : config.env,
      systemCode: null,
      bannerPropById: {},
    };
  },
  created() {
    const code = getSystemCode();
    if (code) {
      this.systemCode = code.toString();
    }
  },
  mounted() {
    this.bannerPropById = {
      id: this.resourceId,
      customClick: this.customClick,
      style: {
        borderRadius: this.borderRadius,
      },
    };
  },
  methods: {
    handleAdvEvent(event = {}) {
      this.$emit('advEvent', event);
    },
  },
};
</script>

<style scoped lang="less">
.banner-container {
  display: block !important;

  /deep/ .wrapper {
    display: block;
  }
}
</style>
